import script from "./forgot-third.vue?vue&type=script&setup=true&lang=js"
export * from "./forgot-third.vue?vue&type=script&setup=true&lang=js"

import "./forgot-third.vue?vue&type=style&index=0&id=33ae6e55&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33ae6e55"]])

export default __exports__